import { c as _c } from "react/compiler-runtime";
import { Box } from "@mui-wrapper";
import { withEllipsis } from "@styles/common-styles";
import { UiUtils } from "@stellar/utils";
/** Renders the progress value of the background task */
export function BackgroundTaskProgress(t0) {
  const $ = _c(3);
  const {
    taskProgress
  } = t0;
  const progress = taskProgress ? taskProgress : UiUtils.DASH;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      ...withEllipsis
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== progress) {
    t2 = <Box sx={t1}>{progress}</Box>;
    $[1] = progress;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}